import './Footer.css'
import application_name from "../constant";
import { faEnvelope, faPhoneAlt  } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faFacebook } from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
const Footer = ({services, abouts}) => {
    return (
        <footer className={"footer-container"}>
            <div className={"footer"}>
                <div className="logo-container">
                    <img src={"logo480.png"} alt="Agri-Tech Solution Madagascar" />
                    <p className={"footer-description"}>
                        <strong>Agri-Tech Solution</strong>, votre partenaire agricole numérique,
                         &nbsp;<i>optimise les rendements</i> et
                        &nbsp;<i>améliore la durabilité</i> pour une agriculture future.
                    </p>
                </div>
                <div className="services">
                    <h3 className={"footer-title"}>Nos Services</h3>
                    <ul>
                        {
                            services.map(service => (
                                <li><a href={"#service"} className={"h-link"}>{service.title}</a></li>
                            ))
                        }
                    </ul>
                </div>
                <div className="about-us">
                    <h3 className={"footer-title"}>Qui Sommes-Nous?</h3>
                    <ul>
                        {
                            abouts.map(about => (
                                <li><a href={"#"+about.link} className={"h-link"}>{about.title}</a></li>
                            ))
                        }
                    </ul>
                </div>
                <div className="contacts">
                    <h3 className={"footer-title"}>Contactez-nous</h3>
                    <p><FontAwesomeIcon icon={faEnvelope} size="lg" /> : agritech.solution01@gmail.com</p>
                    <p><FontAwesomeIcon icon={faPhoneAlt} size="lg" /> : +261 32 15 508 86</p>
                    <p><FontAwesomeIcon icon={faLinkedinIn} size="lg" /> : Agri-Tech Solution</p>
                    <p><FontAwesomeIcon icon={faFacebook} size="lg" /> : Agri-Tech Solution</p>
                </div>
            </div>
            <hr/>
            <div className={"footer"}>
                <div className="copyright">&copy; {new Date().getFullYear()} {application_name}. Tous droits réservés.</div>

            </div>

        </footer>
    )
}

export default Footer;
